export const biteTimeDisplayOf = (min: number, max?: number) => {
  if (min === max) {
    return `${min}+`;
  }
  return `${min} - ${max}`;
};
